import React, { useContext } from 'react'
import { AppContext } from '../AppContext';
import { FontAwesome } from '../data/FontAwesome';
import { Audios } from '../data/Audios'

export default function AlarmList() {

    const { alarmSettings, naflAlarmSettings, updateSettings, isWeekDay, t } = useContext(AppContext)

    function removeAlarm(index) {
        if (alarmSettings) {
            alarmSettings.splice(index, 1)
            updateSettings({ alarmSettings: alarmSettings })
        }
    }

    function removeNaflAlarm(index) {
        if (naflAlarmSettings) {
            naflAlarmSettings.splice(index, 1)
            updateSettings({ naflAlarmSettings: naflAlarmSettings })
        }
    }

    const prayerLabel = (name) => {
        if (name === '1/3 of Night') return t('dashboard.lastThird')
        if (name === 'Midnight') return t('settings.midnight')
        if (name === '2/3 of Night') return t('alarms.twoThirdsNight')
        return t('prayers.' + name) || name
    }
    const whenLabel = (when) => when === 'before' ? t('alarms.before') : t('alarms.after')
    const frequencyLabel = (frequency) => frequency === 'W' ? t('alarms.weekdays') : t('alarms.everyday')

    return (
        <div className='alarm-list-panel'>
            <div className='alarm-list-title'>{t('alarms.savedAlarms')}</div>
            {(alarmSettings) ? alarmSettings.map((a, index) => {

                let audioName = Audios.filter(f => f.id === a.id)[0]?.name
                let isActive = (a.frequency === 'W' && isWeekDay) || a.frequency === 'E'

                return (
                    <div key={'ar' + index} className="alarm-list-card">
                        <div>
                            <span className={(isActive ? 'alarm-dot' : 'gray-dot')}></span> <b>{audioName}</b>
                            <small>{frequencyLabel(a.frequency)} {t('common.at')} {a.hour}:{a.minute} {t('common.' + a.ap)}</small>
                        </div>
                        <button onClick={() => { removeAlarm(index) }} className='alarm-remove'>{FontAwesome.Close}</button>
                    </div>
                )

            }) : null}

            {(naflAlarmSettings) ? naflAlarmSettings.map((a, index) => {

                let audioName = Audios.filter(f => f.id === a.id)[0]?.name

                return (
                    <div key={'nar' + index} className="alarm-list-card">
                        <div>
                            <span className='nafl-alarm-dot'></span> <b>{audioName}</b>
                            <small>{a.minutes} {t('alarms.minuteShort')} {whenLabel(a.when)} {prayerLabel(a.vakit)}</small>
                        </div>
                        <button onClick={() => { removeNaflAlarm(index) }} className='alarm-remove'>{FontAwesome.Close}</button>
                    </div>
                )

            }) : null}

        </div>
    )
}
